import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import DiariasService from '../../../../../services/diarias-auth';
import { Link, useParams, Navigate } from 'react-router-dom';

const Diaria = () => {
    let { id } = useParams()

    const [cargo, setCargo] = useState("");
    const [valor, setValor] = useState("");
    const [distancia, setDistancia] = useState("");
    const [indice, setIndice] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchDiaria(id) {
        const response = await DiariasService.diariaEdit(id);
        setCargo(response.data["cargo"]);
        setValor(response.data["valor"]);
        setDistancia(response.data["distancia"]);
        setIndice(response.data["indice"]);
    }

    useEffect(() => {
        fetchDiaria(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const dira = await DiariasService.editar(id, {
                indice: indice,
                valor: valor,
                distancia: distancia,
                cargo: cargo,
            })
            if (dira.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Índice">
                                <FloatingLabel
                                    label="Índice"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Índice"
                                        name="indice"
                                        onChange={e => setIndice(e.target.value)}
                                    >
                                        <option value={indice}>{indice}</option>
                                        <option value="I">I</option>
                                        <option value="II">II</option>
                                        <option value="III">III</option>
                                        <option value="IV">IV</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={10}>
                            <Form.Group className="mb-3" controlId="distancia">
                                <FloatingLabel
                                    label="Distância"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="distancia"
                                        value={distancia}
                                        onChange={e => setDistancia(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Valor Captado">
                                <FloatingLabel
                                    label="Valor"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="cargo">
                                <FloatingLabel
                                    label="Cargo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="cargo"
                                        value={cargo}
                                        onChange={e => setCargo(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/diarias/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Diaria editada com sucesso!</Alert>
                <Navigate to={'/restrito/diarias/listar'} />
            </Fragment>
        )
    }
}

export default Diaria;